<template>
    <div>
       <FilesBrowseModal v-bind="currentProperties"></FilesBrowseModal>
    </div>
</template>

<script>
import FilesBrowseModal from './AssetFavouriteBrowse.vue';
export default {
  name:'favourites-admin',
  components:{
      FilesBrowseModal
  },
 computed:{
    currentProperties() {          
        return {enableAssetMultiSelect:true, enableBinsWorkspace:true, enableCatalogsWorkspace:true,workspaceList:['catalogs']}
     }
  }
}
</script>

<style scoped>

</style>